// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var CommonTypes_Geocode = require("./CommonTypes_Geocode.bs.js");
var CommonTypes_ZipCode = require("./CommonTypes_ZipCode.bs.js");
var CommonTypes_ZipCode_LaunchStatus = require("./CommonTypes_ZipCode_LaunchStatus.bs.js");

var Raw = {};

function parse(value) {
  var value$1 = value.launchStatus;
  var tmp;
  switch (value$1) {
    case "LAUNCHED" :
        tmp = "LAUNCHED";
        break;
    case "NOT_LAUNCHED" :
        tmp = "NOT_LAUNCHED";
        break;
    case "SUPPLY_LAUNCHED_ONLY" :
        tmp = "SUPPLY_LAUNCHED_ONLY";
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$1
      };
  }
  var value$2 = value.zipcode;
  return {
          formattedAddress: value.formattedAddress,
          lat: value.lat,
          launchStatus: tmp,
          lng: value.lng,
          zipcode: !(value$2 == null) ? Caml_option.some(CommonTypes_ZipCode.GraphQL_API.parse(value$2)) : undefined
        };
}

function serialize(value) {
  var value$1 = value.zipcode;
  var zipcode = value$1 !== undefined ? Curry._1(CommonTypes_ZipCode.GraphQL_API.serialize, Caml_option.valFromOption(value$1)) : null;
  var value$2 = value.lng;
  var value$3 = value.launchStatus;
  var launchStatus = typeof value$3 === "string" ? (
      value$3 === "SUPPLY_LAUNCHED_ONLY" ? "SUPPLY_LAUNCHED_ONLY" : (
          value$3 === "LAUNCHED" ? "LAUNCHED" : "NOT_LAUNCHED"
        )
    ) : value$3.VAL;
  var value$4 = value.lat;
  var value$5 = value.formattedAddress;
  return {
          formattedAddress: value$5,
          lat: value$4,
          launchStatus: launchStatus,
          lng: value$2,
          zipcode: zipcode
        };
}

function verifyArgsAndParse(_CommonTypes_PostAShift_AddressGeocode, value) {
  return parse(value);
}

function verifyName(param) {
  
}

function tToR(param) {
  var zipcode = param.zipcode;
  var lng = param.lng;
  var lat = param.lat;
  var formattedAddress = param.formattedAddress;
  if (zipcode === undefined) {
    return ;
  }
  var zipcode$1 = Caml_option.valFromOption(zipcode);
  return Relude_Option.map((function (launchStatus) {
                return {
                        formattedAddress: formattedAddress,
                        geocode: CommonTypes_Geocode.make(lat, lng),
                        launchStatus: launchStatus,
                        zipcode: zipcode$1
                      };
              }), CommonTypes_ZipCode_LaunchStatus.parseApiResponse(param.launchStatus));
}

var query = "fragment CommonTypes_PostAShift_AddressGeocode on GeocodeAddressPayload   {\nformattedAddress  \nlat  \nlaunchStatus  \nlng  \nzipcode  \n}\n";

exports.Raw = Raw;
exports.query = query;
exports.parse = parse;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.tToR = tToR;
/* Relude_Option Not a pure module */
